import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Input, InputPass } from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Form } from "../../layout";
import * as actions from "../../api/actions/pos";
import { controller, endpoints } from "../../api/actions/api";
import { ToFormData } from "../../hooks/Method";

const Login = (props) => {
  const { _getByObj } = props;
  const { LoginMdl } = Model();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { values, errors, setErrors, handleInpChg } = UseForm(LoginMdl);
  const { t, i18n } = useTranslation();
  const [errMsg, setErrMsg] = useState("");

  const handleLanguageChange = (e) => {
    const language = e.target.value;
    i18n.changeLanguage(language);
    localStorage.setItem("posLanguage", language);
  };

  const validateForm = () => {
    let temp = {};
    temp.companyCode = values.companyCode !== "" ? "" : t("companyCodeRequired");
    temp.userName = values.userName !== "" ? "" : t("userNameRequired");
    temp.password = values.password !== "" ? "" : t("passwordRequired");
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoader(true);
  
    const onComplete = (res, err) => {
      setLoader(false);

      // Server / network error
      if (err) {
        setErrMsg(
          err?.error?.msg ||
          err?.msg ||
          err?.message ||
          t("loginFailed")
        );
        return;
      }

      // Login rejected by backend
      if (res?.status === 401 || res?.status === 403) {
        const backendMsg = res?.error?.msg || res?.msg || "";

        if (backendMsg === "Company is deactivated. Please contact support.") {
          setErrMsg(t("companyInactive"));
        } else if (backendMsg === "Company not found") {
          setErrMsg(t("companyNotFound"));
        } else if (backendMsg === "Invalid username or password") {
          setErrMsg(t("invalidCredentials"));
        } else {
          setErrMsg(t("invalidLogin"));
        }

        return;
      }

      setErrMsg("");
    };

      _getByObj(
        endpoints.Auth + controller.Login,
        ToFormData(values), // ✅ includes companyCode now
        actions.ActionType.Auth,
        onComplete
      );
    }
  };

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Grid container className="p-15 pt-0" maxWidth={400} spacing={3}>

        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel>{t("language")}</InputLabel>

            <Select
              value={i18n.language}
              label={t("language")}
              onChange={handleLanguageChange}
            >
              <MenuItem value="en">{t("english")}</MenuItem>
              <MenuItem value="fr">{t("french")}</MenuItem>
              <MenuItem value="es">{t("spanish")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} className="tx-center gray-color">
          <Grid className="pos-relative mb-20">
            <span className="fw-6 fs-30 tx-upp">{t("login")}</span>
            <div className="bs-bottom mx-w-60 m-auto mt-5" />
          </Grid>
        </Grid>

        <Grid item xs={12} className="tx-center">
          <Typography color="error">{errMsg}</Typography>
        </Grid>

        {/* ✅ Company Code */}
        <Grid item xs={12}>
          <Input
            label={t("companyCode")}
            name="companyCode"
            value={values.companyCode}
            onChange={handleInpChg}
            error={errors.companyCode}
            className="input-primary w-100pr"
            placeholder={t("companyCodePlaceholder")}
          />
        </Grid>

        {/* Username */}
        <Grid item xs={12}>
          <Input
            label={t("username")}
            name="userName"
            value={values.userName}
            onChange={handleInpChg}
            error={errors.userName}
            className="input-primary w-100pr"
          />
        </Grid>

        {/* Password */}
        <Grid item xs={12}>
          <InputPass
            label={t("password")}
            name="password"
            value={values.password}
            onChange={handleInpChg}
            error={errors.password}
            className="input-primary w-100pr"
          />
        </Grid>

        <Grid item xs={12} className="text-center">
          <Button
            loading={loader}
            type="submit"
            className="mb-10 w-100pr"
            size="large"
          >
            {t("login")}
          </Button>
          <Button
            type="button"
            onClick={() => navigate("/forgot")}
            fullWidth
            size="large"
            color="whitesm"
          >
           {t("forgotPassword")}
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

const mapStateToProps = () => ({});

const mapActionToProps = {
  _getByObj: actions.getByObj,
};

export default connect(mapStateToProps, mapActionToProps)(Login);
